import * as React from 'react';
export const earthclassmailSvg = React.forwardRef(
  function earthclassmailSvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#122573',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M4.013 16.532s.553-.189 1.382-.34c0 .453.092.942.184 1.394a.595.595 0 0 0 .553.414h.092c.322-.075.552-.339.506-.527-.092-.452-.184-.941-.184-1.356.921-.075 2.026.076 3.178.452 1.151.414 2.302.527 3.27.527 1.888 0 3.361-.527 3.453-.527l.553-.188-.553-1.017-.552.189s-2.763 1.054-5.71 0c-3.363-1.205-6.54-.076-6.632 0L3 15.74l.507.866.506-.075Zm-.043-4.116s.924-.347 2.218-.424a4.69 4.69 0 0 0-.508 1.39c-.093.27.092.54.416.618h.185c.23 0 .508-.155.554-.425.185-.54.416-1.081.647-1.583.647.077 1.478.193 2.218.463 1.155.425 2.31.54 3.28.54 1.895 0 3.373-.54 3.465-.54l.555-.193-.508-.888-.555.193s-2.772 1.081-5.73 0c-3.372-1.236-6.56-.077-6.653 0L3 11.76l.508.888.462-.232Z',
        fill: '#fff',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M16.19 5C12.953 5 10 6.438 7.905 8.93c-.238.24-.19.67.095.862.238.192.667.192.857-.095 1.857-2.205 4.476-3.499 7.381-3.499 5.333 0 9.667 4.41 9.667 9.777 0 5.367-4.334 9.776-9.667 9.776-3.714 0-7.048-2.109-8.619-5.463.667.096 1.524.24 2.286.575 1.19.527 2.38.67 3.38.67 1.953 0 3.477-.67 3.572-.67l.572-.24-.524-1.102-.572.24s-2.857 1.341-5.904 0c-3.477-1.534-6.762-.096-6.858 0L3 20l.524 1.101.571-.24s.953-.43 2.286-.574c1.714 4.073 5.571 6.709 10 6.709C22.191 27.14 27 22.205 27 16.07 27 9.936 22.19 5 16.19 5Z',
        fill: '#fff',
      }),
    );
  },
);
earthclassmailSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var earthclassmail = {
  category: 'brand',
  colorable: false,
  name: 'earthclassmail',
  svg: earthclassmailSvg,
};
